import { Button } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';

const NotFoundPage = () => {
    const navigate = useNavigate();

    const handleBackButton = ()=>{
     navigate(-1);
    }
    return (
        <div className="flex items-center justify-center min-h-screen p-6 bg-gradient-to-r from-pink-200 via-purple-200 to-blue-200">
            <div className="text-center">
                <h1 className="text-9xl font-bold text-gray-800">404</h1>
                <p className="text-2xl font-semibold text-gray-600 mt-4">Oops! Page not found</p>
                <p className="text-lg text-gray-500 mt-2">The page you’re looking for doesn’t exist.</p>
                <Button variant='containeed' size='large' className='mt-3' onClick={handleBackButton}> Go Back To Previous Page</Button>
            </div>
        </div>
    );
};

export default NotFoundPage;
